
import { Box } from "@chakra-ui/react"
import { BoxData } from "@components";

const PersonDetailsAttr = ({ FieldName, data }) => {
    return(
        <Box
          fontSize="1rem"
          mb="1rem"
          borderBottom="0.3px solid rgba(136, 136, 136, .3)"
          w="294px"
        >
          <Box as="span" fontWeight="300" textColor="gray.borders">
            {FieldName}:
          </Box>
    
          <Box as="span" fontWeight="600" textColor="black" ml=".2rem">
            {data}
          </Box>
        </Box>
    )
}

export default PersonDetailsAttr;